import EditProfile from "../../components/Account/AccountSettings";

const Profile = (props: any) => {
  return <EditProfile />;
};

export default Profile;
